<template>
  <path
    d="M14.6055 12.6945L13.6055 13.6945C12.0055 15.2945 9.50547 15.2945 8.00547 13.6945L2.30547 8.0945C0.705469 6.4945 0.705469 3.9945 2.30547 2.3945L3.30547 1.3945C3.70547 0.994501 4.40547 0.994501 4.80547 1.4945L6.30547 3.3945C6.60547 3.7945 6.60547 4.3945 6.20547 4.6945L4.90547 6.0945L9.90547 11.0945L11.3055 9.6945C11.7055 9.2945 12.2055 9.2945 12.6055 9.5945L14.5055 11.0945C15.0055 11.5945 15.0055 12.2945 14.6055 12.6945Z"
    fill="currentColor"
    :stroke="stroke"
  />
</template>
<script setup lang="ts">
defineProps<{ stroke?: string }>();
</script>
